(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-visual-list"] && !Shopify.designMode) return;
  try {
    
function initCategoryHero(scope = document) {
  scope.querySelectorAll('.category-hero').forEach((root) => {
    const hasItems = root.dataset.hasItems === 'true';
    const links = Array.from(root.querySelectorAll('.category-hero__link'));
    const slides = Array.from(root.querySelectorAll('.category-hero__slide'));
    const total = slides.length;

    if (!links.length || !slides.length) return;

    let active = 0;
    let hoverTimer = null;

    function update() {
      links.forEach((a, i) =>
        a.classList.toggle('is-active', i === active)
      );

      slides.forEach((slide, i) => {
        const order = (i - active + total) % total;
        slide.style.setProperty('--order', order);

        const visible = order <= 2;
        slide.classList.toggle('is-hidden', !visible);
        slide.classList.toggle('is-top', order === 0);

        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        slide.tabIndex = order === 0 ? 0 : -1;
      });
    }

    function setActive(index) {
      active = (index + total) % total;
      update();
    }

    update();

    links.forEach((a) => {
      const idx = parseInt(a.dataset.index, 10);

      const onHover = () => {
        if (Number.isNaN(idx)) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => setActive(idx), 40);
      };

      a.addEventListener('mouseenter', onHover);
      a.addEventListener('focus', onHover);

      if (a.dataset.placeholder === 'true') {
        a.addEventListener('click', (e) => e.preventDefault());
      }
    });

    if (hasItems && window.matchMedia('(hover: none)').matches) {
      links.forEach((a) => {
        a.addEventListener('click', (e) => {
          const idx = parseInt(a.dataset.index, 10);
          if (Number.isNaN(idx)) return;

          if (idx !== active) {
            e.preventDefault();
            setActive(idx);
          }
        });
      });
    }

    const slidesWrap = root.querySelector('.category-hero__slides');
    if (slidesWrap) {
      slidesWrap.addEventListener('click', (e) => {
        if (hasItems) {
          if (e.target.closest('.category-hero__slide.is-top')) return;
        }
        setActive(active + 1);
      });
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  initCategoryHero();
});

document.addEventListener('shopify:section:select', (event) => {
  initCategoryHero(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tinker-promo-timed-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('tinker-timed-banner')) return;
  customElements.define('tinker-timed-banner', class extends HTMLElement {
    connectedCallback() {
      // Wait until the browser has parsed this element's children.
      clearTimeout(this.startTimer);
      this.startTimer = setTimeout(() => { if (this.isConnected) this.init(); }, 0);
    }
    disconnectedCallback() {
      clearTimeout(this.startTimer);
      clearInterval(this.rotation);
      clearInterval(this.scheduleTimer);
      if (this.events) this.events.abort();
    }
    init() {
      if (this.events) this.events.abort();
      clearInterval(this.rotation);
      clearInterval(this.scheduleTimer);
      this.events = new AbortController();
      const on = (target, name, fn) => target.addEventListener(name, fn, {signal:this.events.signal});
      const slides = Array.from(this.querySelectorAll('[data-skch-slide]'));
      const editor = this.dataset.editor === '1';
      const autoplay = this.dataset.autoplay === '1';
      const speed = Number(this.dataset.speed) || 6000;
      const dots = this.querySelector('[data-skch-dots]');
      const nav = this.querySelector('[data-skch-nav]');
      const pause = this.querySelector('[data-skch-pause]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let active = [], current = -1, paused = motion.matches, hover = false, focus = false;
      const stop = () => { clearInterval(this.rotation); this.rotation = null; };
      const syncPause = () => {
        if (pause) {
          pause.textContent = paused ? 'Play' : 'Pause';
          pause.setAttribute('aria-label', paused ? 'Start automatic banner rotation' : 'Pause automatic banner rotation');
        }
      };
      const show = index => {
        current = index;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', String(i !== index));
          slide.inert = i !== index;
        });
        if (dots) Array.from(dots.children).forEach(dot => {
          const selected = Number(dot.dataset.i) === index;
          dot.classList.toggle('is-on', selected);
          dot.setAttribute('aria-current', String(selected));
        });
      };
      const step = direction => {
        if (active.length < 2) return;
        show(active[(active.indexOf(current) + direction + active.length) % active.length]);
      };
      const play = () => {
        stop();
        if (autoplay && !editor && !paused && !hover && !focus && !document.hidden && active.length > 1) {
          this.rotation = setInterval(() => step(1), speed);
        }
      };
      const refresh = () => {
        const now = Date.now() / 1000;
        const next = slides.map((slide, i) => i).filter(i => {
          const slide = slides[i];
          if (editor || slide.dataset.sched !== '1') return true;
          const start = Number(slide.dataset.start) || 0;
          const end = Number(slide.dataset.end) || 0;
          return (!start || now >= start) && (!end || now < end);
        });
        this.hidden = next.length === 0;
        const wrapper = this.closest('.shopify-section');
        if (wrapper) wrapper.hidden = this.hidden;
        if (next.join(',') === active.join(',')) return;
        active = next;
        if (nav) nav.hidden = active.length < 2;
        if (dots) {
          dots.replaceChildren();
          if (active.length > 1) active.forEach((i, position) => {
            const dot = document.createElement('button');
            dot.type = 'button'; dot.className = 'skchtb__dot'; dot.dataset.i = i;
            dot.setAttribute('aria-label', 'Show banner ' + (position + 1) + ' of ' + active.length);
            dots.append(dot);
          });
        }
        show(active.includes(current) ? current : (active[0] ?? -1));
        play();
      };
      if (dots) on(dots, 'click', event => {
        const dot = event.target.closest('[data-i]');
        if (dot) { show(Number(dot.dataset.i)); play(); }
      });
      const prev = this.querySelector('[data-skch-prev]');
      const next = this.querySelector('[data-skch-next]');
      if (prev) on(prev, 'click', () => { step(-1); play(); });
      if (next) on(next, 'click', () => { step(1); play(); });
      if (pause) on(pause, 'click', () => { paused = !paused; syncPause(); play(); });
      on(this, 'mouseenter', () => { hover = true; stop(); });
      on(this, 'mouseleave', () => { hover = false; play(); });
      on(this, 'focusin', () => { focus = true; stop(); });
      on(this, 'focusout', event => { focus = this.contains(event.relatedTarget); play(); });
      on(document, 'visibilitychange', () => { refresh(); play(); });
      on(motion, 'change', () => { paused = motion.matches; syncPause(); play(); });
      on(document, 'shopify:block:select', event => {
        if (!editor) return;
        const slide = event.target.closest('[data-skch-slide]');
        const index = slides.indexOf(slide);
        if (index >= 0) { stop(); show(index); }
      });
      syncPause();
      refresh();
      this.scheduleTimer = setInterval(refresh, 20000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
